import * as THREE from 'three';
export default {
  computed: {
    pdm() {
      return this.$store.state.utils.pdm;
    },
    default_textures() {
      return this.$store.state.sceneSetup.default_textures;
    }
  },
  methods: {
    /**
     * @function setupModelDefaults
     * Starts the process of creating textures and materials for the defaults of a model.
     */
    setupModelDefaults() {
      const components = Object.keys(this.pdm.components);
      components.forEach(componentName => {
        const componentObj = this.pdm.components[componentName];
        if(!componentObj.default_texture) {
          this.applyDefaultMeshOptions(componentName, componentObj);
        }

        const componentMeshObject = this.$model3D.sceneHelpers.getSceneObjectByName({ objectName: componentName });
        if (!componentObj.default_texture && componentMeshObject) {
          this.createMaterialFromMeshOptions(componentName, componentMeshObject, componentObj);
        } else if(componentObj.default_mesh_options && componentMeshObject) {
          this.$model3D.sceneHelpers.updateMaterialOptions({ mesh: componentMeshObject, options: componentObj.default_mesh_options});
        }

        if (!componentObj.visible && componentMeshObject) {
          componentMeshObject.visible = false;
        }

        // set component group parent child configuration
        if(componentObj.component_configuration_group){
          this.$store.commit("componentConfigGroup/SET_COMPONENT_PARENT_CHILD_CONFIGURATION", {
            parentComponent: componentName,
              componentGroup: componentObj.component_configuration_group
          });
        }
      });
    },
    /**
     * @function applyDefaultMeshOptions
     * @param {String} componentName - Name of component to create mesh options
     * @param {Object} componentObj - Data object coming from the PDM
     * Applies a default mesh using the options coming from the pdm.
     */
    applyDefaultMeshOptions(componentName, componentObj) {
        // If mesh_material, get mesh_material obj
        if (componentObj.mesh_material && componentObj.mesh_material.mesh_options) {
          let meshOptions = componentObj.mesh_material.mesh_options;
          // Loop through textures apply to mesh options
          if (this.default_textures && this.default_textures[componentName]) {
            const default_textures = Object.keys(this.default_textures[componentName]);
            default_textures.forEach((mapType, index) => {
              const textureObj = this.default_textures[componentName][mapType];
              meshOptions[mapType] = textureObj;
            });
          }
          this.$model3D.setSubProperty({ property: 'defaultMeshOptions', subproperty: componentName, value: meshOptions });
        }
    },
    /**
     * @function createMaterialFromMeshOptions
     * @param {String} componentName - Name of component to create mesh options
     * @param {Object} componentMeshObject - Data object with mesh options created in applyDefaultMeshOptions
     * @param {Object} componentObj - Component data object coming from the PDM
     * Using the mesh option created and the data from the PDM calls "createMaterial"
     * to create a material for each model component
     */
    createMaterialFromMeshOptions(componentName, componentMeshObject, componentObj){
        if(!componentObj.mesh_material) return false;
        const meshOptions = this.$model3D.defaultMeshOptions[componentName];
        this.$model3D.sceneHelpers.disposeTexture({ textureObj: componentMeshObject });

        componentMeshObject.material = this.$model3D.sceneHelpers.createMaterial({
          mesh_type: componentObj.mesh_material.type,
          options: meshOptions,
          componentName,
          shadersType: componentObj.shader_material
        });

        this.$model3D.sceneHelpers.updateComponentStitching({
          componentName
        });
        if (!componentObj.visible) {
          componentMeshObject.visible = false;
        }
    }

  }
};
